import { inject, Injectable } from '@angular/core';
import { CustomActiveCartService } from '@cart/data-access';
import { CheckoutActions } from '@checkout-v2/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { EMPTY, Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { CheckoutPersistenceService } from '../services/checkout-persistence.service';

/*
 * Нельзя имплементрировать OnRunEffects. так как эффект checkoutPersistanseSync
 * должен выполниться один раз, а не при каждом заходе на страницу чекаута
 * Также нельзя checkoutPersistenceService.sync() перенести на APP_INITIALIZER
 * потому что на экшены вызываемые в нем не успевают реагировать эффекты на запуске приложения
 *  */
@Injectable()
export class CheckoutInitEffects {
  private readonly actions$ = inject(Actions);
  private readonly checkoutPersistenceService = inject(CheckoutPersistenceService);
  private readonly customActiveCartService = inject(CustomActiveCartService);

  // При первом заходе на страницу
  // Восстановить данные в сторе
  syncStorage$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        take(1),
        tap(() => this.checkoutPersistenceService.sync()),
        switchMap(() => EMPTY),
      ),
    { dispatch: false },
  );

  // Инициализация чекаута
  // Загрузка списка способов получения
  loadReceiptTypesOnInit$: Observable<CheckoutActions.LoadReceiptType> = createEffect(() =>
    this.actions$.pipe(
      ofType<CheckoutActions.CheckoutInit>(CheckoutActions.CHECKOUT_INIT),
      concatLatestFrom(() => this.customActiveCartService.isCurrentCartEmpty()),
      filter(([, isCurrentCartEmpty]) => !isCurrentCartEmpty),
      map(() => new CheckoutActions.LoadReceiptType()),
    ),
  );
}
